import moment from 'moment'

export default function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YY')
  }
}


// WEBPACK FOOTER //
// ./src/filters/shortShortDate.js